import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import moment from "moment";
import {
  getAccessSettings,
  removeNonNumeric,
  SortTheList,
} from "../Shared/Utility";
import InputMask from "../App/InputMask";
import { useGlobalState } from "../Context/GlobalStateContext";
import Confirmation from "../App/Confirmation";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
export default function InvoicesData() {
  const globalState = useGlobalState();

  const [invoicesGridData, setInvoicesGridData] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);

  const [invoicesFilter, setInvoicesFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [brandList, setBrandList] = useState<any>([
    {
      PID: 2,
      Name: "All Brands",
    },
    {
      PID: 3,
      Name: "PFI Brand 3",
    },
    {
      PID: 4,
      Name: "PFI Brand 4",
    },
  ]);

  const [paymentType, setPaymentType] = useState<any>([
    {
      PID: "",
      Name: "Please Select",
    },
    {
      PID: "Quarterly VIM",
      Name: "Quarterly VIM",
    },
    {
      PID: "Conditional hold",
      Name: "Conditional hold",
    },
  ]);

  const [importerList, setImporterList] = useState<any>([]);
  const [invoiceData, setInvoiceData] = useState<any>({});
  const [invoicesTotalData, setInvoicesTotalData] = useState<any>({});
  const [importerAvailableAmountsData, setImporterAvailableAmountsData] =
    useState<any>([]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = invoicesFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = invoicesFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = invoicesFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = invoicesFilter.ProgramID;

    setInvoicesFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
  }, []);

  useEffect(() => {
    if (invoicesFilter.ProgramID > 0) {
      IBBProgramGetScorecardListForScorecard();
    }
  }, [invoicesFilter.ProgramID, invoicesFilter.QuarterID]);

  useEffect(() => {
    if (programList.length > 0) {
      IBBScorecardInvoiceGetCompleteGridDataCustom();
    }
  }, [
    programList,
    invoicesFilter.ProgramID,
    invoicesFilter.QuarterID,
    invoicesFilter.IBBScorecardID,
  ]);

  useEffect(() => {
    if (invoiceData.IBBScorecardID > 0 && invoiceData.PFIBrandID > 0) {
      assignAvailableAmount();
      getCurrencyIDByIBBScorecardID();
    }
  }, [invoiceData.IBBScorecardID, invoiceData.PFIBrandID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = invoicesFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = invoicesFilter.ProgramID;
    object.numericquarter = invoicesFilter.QuarterID;
    object.pfidealerid = invoicesFilter.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            if (
              result[0].length > 0 &&
              globalState.AppAccessLevelData.DID > 0
            ) {
              let IBBScorecardID = result[0][0].PID;
              setInvoicesFilter((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardInvoiceGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = invoicesFilter.ProgramID;
    object.quarterid = invoicesFilter.QuarterID;
    object.ibbscorecardid = invoicesFilter.IBBScorecardID;
    object.recordsperpage = 1000;
    object.isdeleted = false;
    setInvoicesGridData([]);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardInvoice/IBBScorecardInvoiceGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[0].length > 0) setInvoicesTotalData(result[0][0]);
            //setInvoicesGridData(result[1]);
            setImporterAvailableAmountsData(result[2]);

            const deepCopy1 = JSON.parse(JSON.stringify(result[1]));
            const deepCopy2 = JSON.parse(JSON.stringify(result[1]));
            setThisGridListDataWithoutFilters(deepCopy1);
            setInvoicesGridData(deepCopy2);
            setThisGridListData(deepCopy2);
            thisGridListDataRef.current = deepCopy2;
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeInvoiceFile,
    MaxAllowedFiles: 1,
    UploadType: 100,
    FolderName: "IBB-Invoices-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles(ObjectType: number, ObjectID: number) {
    if (
      invoiceData.IsDisclaimerAccepted != null &&
      invoiceData.IsDisclaimerAccepted != "" &&
      invoiceData.IsDisclaimerAccepted == true
    ) {
      if (invoiceData.IBBScorecardID > 0) {
        var filtered = importerAvailableAmountsData.filter(
          (item: any) => item.IBBScorecardID == invoiceData.IBBScorecardID
        );
        if (filtered.length > 0 && invoiceData.AmountInLC > 0) {
          let IsOKToGo = true;

          if (invoiceData.Amount > invoiceData.AmountInLC) {
            IsOKToGo = false;
            AppContext.ShowNotification(
              "error",
              "The entered amount should not be more than available amount."
            );
          }

          if (IsOKToGo) {
            if (uploadFileList && uploadFileList.length > 0)
              SaveFiles(ObjectType, ObjectID);
            else if (invoiceData.FileURL != null && invoiceData.FileURL != "")
              IBBScorecardInvoiceSaveCustom([]);
            else
              globalState.setNotificationObject({
                ShowPopup: true,
                Heading: "Alert",
                Message: "Please select file to upload.",
              });
          }
        } else
          AppContext.ShowNotification(
            "error",
            "Amount should be greater than 0."
          );
      } else AppContext.ShowNotification("error", "Please select Importer.");
    } else
      AppContext.ShowNotification("error", "Please accept the disclaimer.");
  }

  function SaveFiles(ObjectType: number, ObjectID: number) {
    if (uploadFileList && uploadFileList.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = ObjectType;
      object.objectid = ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            IBBScorecardInvoiceSaveCustom(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
    }
  }
  //Dragdrop ends

  function IBBScorecardInvoiceSaveCustom(uploadedFile: any) {
    let AmountInUSD = invoiceData.AmountInUSD;

    if (globalState.AppAccessLevelData.DID == 0) {
      let percentageDiff = AmountInUSD / invoiceData.AmountInLC;
      AmountInUSD = invoiceData.Amount * percentageDiff;
    }
    
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbscorecardinvoiceid = invoiceData.IBBScorecardInvoiceID;
    object.ibbprogramid = invoicesFilter.ProgramID;
    object.ibbscorecardid = invoiceData.IBBScorecardID;
    object.quarterid = invoicesFilter.QuarterID;
    object.pfibrandid = invoiceData.PFIBrandID;
    object.name = invoiceData.Name;
    object.objecttype = 1;
    object.objectid = invoicesFilter.IBBScorecardID;
    object.uploadedby = invoiceData.UploadedBy;
    object.amountinlc = invoiceData.Amount;
    object.amountinusd = AmountInUSD;
    object.fileurl = invoiceData.FileURL;
    object.status = invoiceData.Status;
    object.paymentdate = invoiceData.PaymentDate;
    object.filesdata = uploadedFile;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardInvoice/IBBScorecardInvoiceSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          setCurrentView(1);
          IBBScorecardInvoiceGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardInvoiceDeleteRecordCustom(
    IBBScorecardInvoiceID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbscorecardinvoiceid = IBBScorecardInvoiceID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardInvoice/IBBScorecardInvoiceDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBScorecardInvoiceGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function InputMaskOnChangeHandler(e: any) {
    let Amount = removeNonNumeric(e.Value);
    setInvoiceData((prevState: any) => ({
      ...prevState,
      Amount: Amount,
    }));
  }

  function InputMaskOnBlurHandler(e: any) {}

  function assignAvailableAmount() {
    var filtered = importerAvailableAmountsData.filter(
      (item: any) => item.IBBScorecardID == invoiceData.IBBScorecardID
    );
    if (filtered.length > 0) {
      let JaguarAvailableAmount =
        filtered[0].JaguarFinalPayoutInLC -
        filtered[0].JaguarAlreadyInvoicedInLC;

      let LandRoverAvailableAmount =
        filtered[0].LandRoverFinalPayoutInLC -
        filtered[0].LandRoverAlreadyInvoicedInLC;

      let JLRAvailableAmount =
        filtered[0].JaguarFinalPayoutInLC +
        filtered[0].LandRoverFinalPayoutInLC -
        filtered[0].JLRAlreadyInvoicedInLC;

      let AmountInLC = 0 as any;

      if (invoiceData.PFIBrandID == 2) {
        AmountInLC = JLRAvailableAmount;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 2
        )
          AmountInLC += invoiceData.AmountInLCBK;
      } else if (invoiceData.PFIBrandID == 3) {
        AmountInLC = JaguarAvailableAmount;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 3
        )
          AmountInLC += invoiceData.AmountInLCBK;
      }
      if (invoiceData.PFIBrandID == 4) {
        AmountInLC = LandRoverAvailableAmount;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 4
        )
          AmountInLC += invoiceData.AmountInLCBK;
      }

      let JaguarAvailableAmountInUSD =
        filtered[0].JaguarFinalPayoutInUSD -
        filtered[0].JaguarAlreadyInvoicedInUSD;

      let LandRoverAvailableAmountInUSD =
        filtered[0].LandRoverFinalPayoutInUSD -
        filtered[0].LandRoverAlreadyInvoicedInUSD;

      let JLRAvailableAmountInUSD =
        filtered[0].JaguarFinalPayoutInUSD +
        filtered[0].LandRoverFinalPayoutInUSD -
        filtered[0].JLRAlreadyInvoicedInUSD;

      let AmountInUSD = 0 as any;
      // if (invoiceData.PFIBrandID == 2) {
      //   AmountInUSD = JLRAvailableAmountInUSD;
      // } else if (invoiceData.PFIBrandID == 3) {
      //   AmountInUSD = JaguarAvailableAmountInUSD;
      // }
      // if (invoiceData.PFIBrandID == 4) {
      //   AmountInUSD = LandRoverAvailableAmountInUSD;
      // }

      if (invoiceData.PFIBrandID == 2) {
        AmountInUSD = JLRAvailableAmountInUSD;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 2
        )
          AmountInUSD += invoiceData.AmountInUSDBK;
      } else if (invoiceData.PFIBrandID == 3) {
        AmountInUSD = JaguarAvailableAmountInUSD;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 3
        )
          AmountInUSD += invoiceData.AmountInUSDBK;
      }
      if (invoiceData.PFIBrandID == 4) {
        AmountInUSD = LandRoverAvailableAmountInUSD;
        if (
          invoiceData.IBBScorecardInvoiceID > 0 &&
          invoiceData.PFIBrandIDBK == 4
        )
          AmountInUSD += invoiceData.AmountInUSDBK;
      }

      AmountInLC = Number(AmountInLC).toFixed(0);
      AmountInUSD = Number(AmountInUSD).toFixed(0);

      setInvoiceData((prevState: any) => ({
        ...prevState,
        Amount: AmountInLC,
        AmountInLC: AmountInLC,
        AmountInUSD: AmountInUSD,
      }));
    } else {
      setInvoiceData((prevState: any) => ({
        ...prevState,
        Amount: 0,
        AmountInLC: 0,
        AmountInUSD: 0,
      }));
    }
  }

  function getCurrencyIDByIBBScorecardID() {
    var filtered = importerList.filter(
      (item: any) => item.PID == invoiceData.IBBScorecardID
    );
    if (filtered.length > 0) {
      setInvoiceData((prevState: any) => ({
        ...prevState,
        CurrencyID: filtered[0].CurrencyID,
      }));
    }
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBScorecardInvoiceDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setInvoicesGridData(deepCopy);
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["", "D"]);

  useEffect(() => {
    SetSortingImage();
  }, [invoicesGridData, currentView]);

  function SetSortingImage() {
    if (
      invoicesGridData &&
      invoicesGridData.length > 0 &&
      document.getElementById("imgSortIBBScorecardName")
    ) {
      (
        document.getElementById("imgSortIBBScorecardName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortPFIBrandName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortUploadedByName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

      (
        document.getElementById("imgSortAmountInLC") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Quarterly VRM Invoices</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <div style={{ width: "33.33%" }}>
                <select
                  className="select-md"
                  value={invoicesFilter.ProgramID}
                  onChange={(e) => {
                    setInvoicesFilter((prevState: any) => ({
                      ...prevState,
                      ProgramID: Number(e.target.value),
                      QuarterID: 0,
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      IBBProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    IBBProgramGetProgramListForScorecard(
                      Number(e.target.value),
                      0,
                      0,
                      0
                    );
                  }}
                >
                  {programList &&
                    programList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"program" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
                <select
                  style={{ marginLeft: 5 }}
                  className="select-md"
                  value={invoicesFilter.QuarterID}
                  onChange={(e) => {
                    setInvoicesFilter((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                  }}
                >
                  {quarterList &&
                    quarterList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"quarter" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              {globalState.AppAccessLevelData.DID == 0 && (
                <div>
                  <select
                    className="select-lg"
                    value={invoicesFilter.IBBScorecardID}
                    onChange={(e) =>
                      setInvoicesFilter((prevState: any) => ({
                        ...prevState,
                        IBBScorecardID: Number(e.target.value),
                      }))
                    }
                  >
                    <option value={0} key={"importer" + 0}>
                      All
                    </option>
                    {importerList &&
                      importerList.map((Item: any, index: any) => (
                        <option value={Item.PID} key={"importer" + Item.PID}>
                          {Item.Name}
                        </option>
                      ))}
                  </select>
                </div>
              )}
              <span style={{ width: "33.33%" }}></span>

              <span></span>
              <div className="flex-items">
                {getAccessSettings(2, 11) > 1 && (
                  <a
                    className="btn-link"
                    onClick={() => {
                      let IBBScorecardID = invoicesFilter.IBBScorecardID;
                      if (globalState.AppAccessLevelData.DID > 0)
                        setInvoiceData({
                          IBBScorecardID: IBBScorecardID,
                          PFIBrandID: 2,
                          Amount: 0,
                          AmountInLC: 0,
                          PaymentDate: null,
                        });
                      else
                        setInvoiceData({
                          Amount: 0,
                          AmountInLC: 0,
                          PFIBrandID: 2,
                          PaymentDate: null,
                        });
                      setCurrentView(2);
                      setCanEdit(true);
                    }}
                  >
                    Add Invoice
                  </a>
                )}

                <a
                  className="btn-primary"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblQuarterlyIBBInvoices",
                      "QuarterlyIBBInvoices"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flex-container">
              <div className="flex-items sm-re-earn">
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Final Payout:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.FinalPayout?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Invoiced Amount:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.AlreadyInvoiced?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Invoice Required:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.InvoiceRequired?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Paid:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.Paid?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
              </div>
            </div>
            <div className="section-table remove-scroll">
              {invoicesGridData && invoicesGridData.length > 0 && (
                <ColumnFilterCheckboxList
                  DataType={1}
                  RefreshFilters={refreshFilters}
                  ClearFilters={clearFilters}
                  GridData={invoicesGridData}
                  ColumnName={selectedColumnName}
                  ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                  GetFilteredLists={getFilteredLists}
                  ReturnAllFilterdLists={{}}
                  ClickPosition={clickPosition}
                  Orientation={"Center"}
                  ColumnOrientation={[
                    { Name: "IBBScorecardName", Orientation: "Right" },
                  ]}
                />
              )}

              <table
                className="part-head trend-table fixed-table copa-in-d-table"
                id="tblQuarterlyIBBInvoices"
              >
                <thead>
                  <tr>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) =>
                          ShowColumnFilterList(e, "IBBScorecardName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        Importer
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("IBBScorecardName")}
                        title="Sort By Importer"
                      >
                        <span id="imgSortIBBScorecardName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) => ShowColumnFilterList(e, "PFIBrandName")}
                        data-function="ShowColumnFilterList"
                      >
                        Brand
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("PFIBrandName")}
                        title="Sort By Brand"
                      >
                        <span id="imgSortPFIBrandName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) => ShowColumnFilterList(e, "Name")}
                        data-function="ShowColumnFilterList"
                      >
                        Payment Type
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("Name")}
                        title="Sort By Payment Type"
                      >
                        <span id="imgSortName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) =>
                          ShowColumnFilterList(e, "UploadedByName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        Uploaded By
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("UploadedByName")}
                        title="Sort By Uploaded By"
                      >
                        <span id="imgSortUploadedByName"></span>
                      </a>
                    </th>
                    <th>
                      Amount
                      <a
                        onClick={() => LoadWithSelectedSort("AmountInLC")}
                        title="Sort By Uploaded By"
                      >
                        <span id="imgSortAmountInLC"></span>
                      </a>
                    </th>
                    {/* <th>Invoice File</th> */}
                    {/* <th>Status</th> */}
                    <th>Payment Expected Date</th>
                    <th className="sm-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {thisGridListData &&
                    thisGridListData.map((item: any, index: any) => (
                      <React.Fragment key={"program" + index}>
                        {!item.IsExcluded && (
                          <tr>
                            <td>{item.IBBScorecardName}</td>
                            <td>{item.PFIBrandName}</td>
                            <td>{item.Name}</td>
                            <td>{item.UploadedByName}</td>
                            <td className="text-right">
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                item.CurrencyID
                              )}
                              {item.AmountInLC?.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </td>

                            <td>
                              {item.PaymentDate != undefined &&
                                item.PaymentDate != "" && (
                                  <>
                                    {moment(item.PaymentDate).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </>
                                )}
                            </td>

                            <td className="sm-col">
                              <div
                                className="width-100 text-center btn-sm-grid"
                                style={{ justifyContent: "flex-start" }}
                              >
                                <a
                                  className="btn-primary btn-grid"
                                  href={item.FileURL}
                                  target="blank"
                                >
                                  <img
                                    src="images/download.svg"
                                    width={12}
                                    height={12}
                                  />
                                </a>
                                {(item.Status == 0 ||
                                  globalState.ManageAdmin == true) &&
                                  getAccessSettings(2, 11) > 1 && (
                                    <a
                                      className="btn-primary btn-grid"
                                      onClick={() => {
                                        let localItem = item;
                                        localItem.Amount = item.AmountInLC;
                                        localItem.AmountInUSD =
                                          item.AmountInUSD;
                                        localItem.AmountInLCBK =
                                          item.AmountInLC;
                                        localItem.AmountInUSDBK =
                                          item.AmountInUSD;
                                        localItem.PFIBrandIDBK =
                                          item.PFIBrandID;
                                        setCurrentView(3);
                                        setInvoiceData(localItem);
                                      }}
                                      title={
                                        item.Status == 0
                                          ? "Edit "
                                          : "View Details"
                                      }
                                    >
                                      <img
                                        src="images/edit.svg"
                                        width={15}
                                        height={15}
                                      />
                                    </a>
                                  )}
                                {item.Status == 0 &&
                                  getAccessSettings(2, 11) > 1 && (
                                    <>
                                      <a
                                        className="btn-primary btn-grid"
                                        // onClick={() => {
                                        //   IBBScorecardInvoiceDeleteRecordCustom(
                                        //     item.IBBScorecardInvoiceID
                                        //   );
                                        // }}
                                        onClick={() => {
                                          globalState.setConfirmationObject({
                                            ShowPopup: true,
                                            Heading: "Confirmation ",
                                            Message:
                                              "Are you sure you want to delete this record?",
                                            ID: 1,
                                            SelectedID:
                                              item.IBBScorecardInvoiceID,
                                          });
                                        }}
                                        title="Delete"
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {currentView > 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Invoice Data</a>}
            {currentView == 3 && canEdit && <a>Edit Invoice Data</a>}
            {!canEdit && <a>Invoice Details</a>}
          </div>
          <div className="page--data">
            <div className="flex-container">
              <div className="flex-items">
                <b>
                  {programList &&
                    programList.map((item: any, index: any) => (
                      <>
                        {item.PID == invoicesFilter.ProgramID && (
                          <span> {item.Name}</span>
                        )}
                      </>
                    ))}

                  {quarterList &&
                    quarterList.map((item: any, index: any) => (
                      <>
                        {item.PID == invoicesFilter.QuarterID && (
                          <span> - {item.Name}</span>
                        )}
                      </>
                    ))}
                </b>
              </div>
            </div>
            <div className="form-item disclaimer-check">
              <input
                type="checkbox"
                className="input-check"
                checked={invoiceData.IsDisclaimerAccepted}
                onChange={(e) =>
                  setInvoiceData((prevState: any) => ({
                    ...prevState,
                    IsDisclaimerAccepted: !invoiceData.IsDisclaimerAccepted,
                  }))
                }
              />
              <span>
                I confirm that the invoice amount is same as shown by system.
              </span>
            </div>
            <div className="program-form">
              {globalState.AppAccessLevelData.DID == 0 && (
                <div className="form-item">
                  <span>Importer:</span>
                  <div style={{ width: "33.33%" }}>
                    <select
                      disabled={
                        globalState.AppAccessLevelData.DID > 0 ? true : false
                      }
                      className="select-sm"
                      value={invoiceData.IBBScorecardID}
                      onChange={(e) =>
                        setInvoiceData((prevState: any) => ({
                          ...prevState,
                          IBBScorecardID: Number(e.target.value),
                        }))
                      }
                    >
                      <option value={0} key={"importer" + 0}>
                        Please Select
                      </option>
                      {importerList &&
                        importerList.map((Item: any, index: any) => (
                          <option value={Item.PID} key={"importer" + Item.PID}>
                            {Item.Name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              )}

              <div className="form-item">
                <span>Brand:</span>
                <div style={{ width: "33.33%" }}>
                  <select
                    style={{ marginLeft: 5 }}
                    className="select-sm"
                    value={invoiceData.PFIBrandID}
                    onChange={(e) =>
                      setInvoiceData((prevState: any) => ({
                        ...prevState,
                        PFIBrandID: Number(e.target.value),
                      }))
                    }
                  >
                    {brandList &&
                      brandList.map((Item: any, index: any) => (
                        <option value={Item.PID} key={"brand" + Item.PID}>
                          {Item.Name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="form-item">
                <span>Payment Type:</span>
                <div style={{ width: "33.33%" }}>
                  <select
                    style={{ marginLeft: 5 }}
                    className="select-sm"
                    value={invoiceData.Name}
                    onChange={(e) =>
                      setInvoiceData((prevState: any) => ({
                        ...prevState,
                        Name: e.target.value,
                      }))
                    }
                  >
                    {paymentType &&
                      paymentType.map((Item: any, index: any) => (
                        <option value={Item.PID} key={"paymentType" + Item.PID}>
                          {Item.Name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="form-item">
                <span>Amount:</span>

                <InputMask
                  Disabled={
                    globalState.AppAccessLevelData.DID == 0 &&
                    getAccessSettings(2, 11) > 1
                      ? false
                      : true
                  }
                  Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                    invoiceData.CurrencyID
                  )}
                  Suffix={""}
                  ToFixed={0}
                  ClassName=""
                  ColumnName="1"
                  Value={Number(invoiceData.Amount)}
                  PID={1}
                  onChangeHandler={InputMaskOnChangeHandler}
                  onBlurHandler={InputMaskOnBlurHandler}
                />
              </div>

              <div className="form-item">
                <span>Invoice:</span>
                <div className="flex-items supp-doc inv-doc">
                  <div className="order-drag">
                    <DragDrop
                      ParentFeatures={dragDropFeatures}
                      DragDropCallback={handleDragDropCallback}
                      TriggerChild={triggerChild}
                    />
                  </div>
                </div>
              </div>

              {getAccessSettings(2, 11) > 1 &&
                globalState.AppAccessLevelData.DID == 0 && (
                  <div className="form-item">
                    <span>Payment Expected Date:</span>
                    <input
                      type="date"
                      value={moment(invoiceData.PaymentDate).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) => {
                        setInvoiceData((prevState: any) => ({
                          ...prevState,
                          PaymentDate: e.target.value,
                        }));
                      }}
                    ></input>
                  </div>
                )}

              <div className="form-btns">
                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() =>
                    showPopUpForSaveFiles(
                      AppContext.FileUploadObjectTypeInvoiceFile,
                      invoiceData.IBBScorecardID
                    )
                  }
                >
                  Save
                </a>
                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() => {
                    setCurrentView(1);
                  }}
                >
                  Back to List View
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
